export type CNotificationBarBlock = {
  __typename?: 'notificationBar_block_Entry'
  notificationBarCopy?: string
  notificationBarLink?: string
}

type Props = {
  field?: Array<CNotificationBarBlock>
}

const stripAnchorTags = (html: string) => {
  return html
    .replace(/<a\b[^>]*>/gi, '')
    .replace(/<\/a>/gi, '')
}

const normalizeHref = (href: string) => {
  const trimmed = href.trim()

  if (!trimmed) return ''

  if (/^(https?:\/\/|mailto:|tel:|\/\/|#)/i.test(trimmed)) {
    return trimmed
  }

  if (/^www\./i.test(trimmed)) {
    return `https://${trimmed}`
  }

  if (trimmed.startsWith('/')) {
    return trimmed
  }

  return `/${trimmed}`
}

const isExternalHref = (href: string) => {
  return /^(https?:\/\/|mailto:|tel:|\/\/)/i.test(href)
}

const CNotificationBar = ({ field }: Props) => {
  const block = field?.[0]
  const rawCopy = block?.notificationBarCopy?.trim()
  const rawHref = block?.notificationBarLink?.trim()

  if (!rawCopy) return null

  const copy = rawHref ? stripAnchorTags(rawCopy) : rawCopy
  const href = rawHref ? normalizeHref(rawHref) : ''

  const content = (
    <div className="w-full bg-primary-teal px-5 py-2 text-center">
      <div
        className="text-sm md:text-base text-white [&_p]:m-0 [&_a]:underline"
        dangerouslySetInnerHTML={{ __html: copy }}
      />
    </div>
  )

  if (!href) {
    return <div className="c-notification-bar">{content}</div>
  }

  return (
    <a
      className="c-notification-bar block w-full transition-opacity duration-300 hover:opacity-90"
      href={href}
      {...(isExternalHref(href) ? { rel: 'noopener noreferrer' } : {})}
    >
      {content}
    </a>
  )
}

export { CNotificationBar }

export { CNotificationBarFragments } from '../../fragments/c-notifications-bar'
